import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalSignOutService } from './modal-sign-out.service';
import { ToasterService } from '../toastr/toaster.service';
import { AuthService } from '../services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-modal-sign-out',
  templateUrl: './modal-sign-out.component.html',
  styleUrl: './modal-sign-out.component.css'
})
export class ModalSignOutComponent implements OnInit {
  showModal = false;

  constructor(
    private modalService: ModalSignOutService,
    private authService: AuthService,
    private router: Router,
    private toastr: ToasterService,
    private spinner: NgxSpinnerService

  ) { }

  ngOnInit(): void {
    // Subscribe to modal state changes
    this.modalService.modalState$.subscribe(state => {
      this.showModal = state;

      // When modal opens, add class to prevent body scrolling
      if (state) {
        document.body.classList.add('modal-open');
      } else {
        document.body.classList.remove('modal-open');
      }
    });
  }

  closeModal(): void {
    this.modalService.closeModal();
  }

  /**
   * Handle sign out action
   */

  signOut(): void {
    // Ambil token dari localStorage
    const token = localStorage.getItem('token');

    if (token) {
      // Panggil API logout dengan token
      this.authService.logout(token).subscribe({
        next: (response) => {
          console.log('Logout API response:', response);

          // Cek apakah response success benar-benar true
          if (response.success === true) {
            console.log('Logout successful, clearing all localStorage items');

            // Hapus SEMUA item localStorage termasuk token dan currentUser
            this.clearAllLocalStorageItems();

            // Tutup modal
            this.modalService.closeModal();

            // Tampilkan notifikasi
            this.toastr.success('Success', response.message || 'You have been logged out successfully');

            // Navigasi ke halaman login
            setTimeout(() => {
              this.router.navigate(['/login'], { replaceUrl: true });
            }, 100);
          } else {
            console.log('Logout failed:', response?.message);
            this.toastr.error('Error', response?.message || 'Logout failed');
            this.modalService.closeModal();
          }
        },
        error: (error) => {
          console.error('Error during logout API call:', error);

          // Meskipun API error, tetap hapus localStorage untuk keamanan
          console.log('Clearing localStorage due to API error');
          this.clearAllLocalStorageItems();

          this.toastr.error('Error', error.error?.message || 'Failed to communicate with the server');
          this.modalService.closeModal();

          // Tetap navigasi ke login meskipun API error
          setTimeout(() => {
            this.router.navigate(['/login'], { replaceUrl: true });
          }, 100);
        }
      });
    } else {
      console.log('No token found, clearing all localStorage');

      // Hapus semua localStorage
      this.clearAllLocalStorageItems();

      // Tutup modal
      this.modalService.closeModal();

      // Tampilkan notifikasi
      this.toastr.info('Info', 'You have been logged out');

      // Navigasi ke login
      setTimeout(() => {
        this.router.navigate(['/login'], { replaceUrl: true });
      }, 100);
    }
  }

  // Helper method untuk membersihkan localStorage
  private clearAllLocalStorageItems(): void {
    // Daftar semua item yang perlu dihapus
    const itemsToRemove = [
      'token',
      'currentUser',
      'sidebarState',
      'startDate',
      'endDate',
      'rangeType',
      'item_tax',
      'item_rev_category',
      'item_price'
    ];

    // Hapus satu per satu
    itemsToRemove.forEach(item => {
      localStorage.removeItem(item);
      console.log(`Removed ${item} from localStorage`);
    });

    // Alternatif: jika ingin hapus semua localStorage (hati-hati!)
    // localStorage.clear();
  }

  /**
   * Stop event propagation when clicking on modal content
   */
  stopPropagation(event: Event): void {
    event.stopPropagation();
  }
}
